/**
 * Bancos para o seletor de TED, com o ISPB de cada um.
 *
 * ── Por que uma lista, e por que o ISPB ──
 *
 * O provedor aceita o banco por ISPB (8 dígitos, do Banco Central) ou por número de
 * compensação. O ISPB é o que não muda e o que não se confunde: há bancos com números de
 * compensação parecidos, e digitar o número errado manda o dinheiro para outra instituição.
 * Num seletor, quem opera escolhe o NOME e o código vai certo.
 *
 * A lista vivia como propriedade de classe dentro do componente de TED antigo. Extraída para
 * cá porque a tela nova precisa da mesma: duas cópias divergiriam no primeiro banco
 * acrescentado só num lado, e a divergência apareceria como TED recusado.
 */
export const BANKS = [
    { name: 'Banco do Brasil S.A.', ispb: '00000000' },
    { name: 'Caixa Econômica Federal', ispb: '00360305' },
    { name: 'Itaú Unibanco S.A.', ispb: '60701190' },
    { name: 'Bradesco S.A.', ispb: '60746948' },
    { name: 'Santander (Brasil) S.A.', ispb: '90400888' },
    { name: 'Banco Inter S.A.', ispb: '00416968' },
    { name: 'Nubank S.A.', ispb: '18236120' },
    { name: 'BTG Pactual S.A.', ispb: '30306294' },
    { name: 'Banco Safra S.A.', ispb: '58160789' },
    { name: 'C6 Bank S.A.', ispb: '32062580' },
    { name: 'Banco Original S.A.', ispb: '92874270' },

    { name: 'Banco BNP Paribas Brasil S.A.', ispb: '01522368' },
    { name: 'Banco Citibank S.A.', ispb: '33479023' },
    { name: 'Banco Confidence de Câmbio S.A.', ispb: '11703662' },
    { name: 'Banco Cooperativo Sicredi S.A.', ispb: '01181521' },
    { name: 'Banco Crefisa S.A.', ispb: '61033106' },
    { name: 'Banco do Estado do Rio Grande do Sul S.A. (Banrisul)', ispb: '92702067' },
    { name: 'Banco Modal S.A.', ispb: '30723886' },
    { name: 'Banco Société Générale Brasil S.A.', ispb: '61533584' },
    { name: 'BRB – Banco de Brasília S.A.', ispb: '00000208' },
    { name: 'Natixis Brasil S.A. Banco Múltiplo', ispb: '09274232' },
    { name: 'Banco Mercantil do Brasil S.A.', ispb: '17184037' },
    { name: 'Banco Votorantim S.A.', ispb: '59588111' },
    { name: 'Banco Daycoval', ispb: '62232889' },
    { name: 'Banco Sofisa S.A.', ispb: '60889128' },
    { name: 'Banco Semear S.A.', ispb: '00795423' },
    { name: 'Banco Rural Mais', ispb: '072XXXXX' },
    { name: 'Banco Bradescard', ispb: '4184779' },
    { name: 'Banco Safra Cartões', ispb: '59438325' },
    { name: 'Banco Bradesco Financiamentos', ispb: '7207996' },

    { name: 'Bancoob – Banco Cooperativo do Brasil S.A.', ispb: '002038232' },
    { name: 'Banco Cetelem S.A.', ispb: '0000558456' },
    { name: 'Banco Semear S.A.', ispb: '00795423' },
    { name: 'Banco Rib. Preto S.A.', ispb: '00517645' },

    { name: 'Banco de Tokyo-Mitsubishi UFJ Brasil S.A.', ispb: '60498557' },
];

export default BANKS;
